<template>
  <div class="flowmap-box">
    <w-flow-map-flow-field :perf-records="rscPerfData" :perf-key="showFlowFieldLabel? 'SYSSTAT/DB_CLIENT_RECVSIZE' : ''" :arrow-settings="arrowSettings" label="수신량" />
    <div class="flowmap-header">
      User Process
    </div>
    <div class="flowmap-content">
      <ul class="flowmap-list">
        <w-flow-map-item-label :perf-records="rscPerfData" perf-key="SYSSTAT/DB_RESPONSETIME" label="응답 시간" />
        <w-flow-map-item-label :perf-records="rscPerfData" perf-key="SESS/DB_SESS_USERATE" :isValue="false" label="세션 사용률">
          <w-flow-map-progressbar slot="progressbar" :perf-records="rscPerfData" perf-key="SESS/DB_SESS_USERATE" />
        </w-flow-map-item-label>
        <w-flow-map-item-label :perf-records="rscPerfData" perf-key="DBMS_SESSION_MAX_COUNT" label="최대 세션 수" />
        <w-flow-map-item-label :perf-records="rscPerfData" perf-key="SESS/DB_SESS_COUNT" label="현재 세션 수" />
        <w-flow-map-item-label :perf-records="rscPerfData" perf-key="SESS/DB_SESS_ACTIVE_COUNT" label="액티브 세션 수" />
        <w-flow-map-item-label :perf-records="rscPerfData" perf-key="SESS/DB_SESS_CPU_TIME" label="세션사용 CPU 시간" />
      </ul>
    </div>
  </div>
</template>

<script>
import isNil from 'lodash/isNil';
import WRscPerfEventTextLabel from '@/components/textLabel/RscPerfEventTextLabel';
import WFlowMapProgressbar from './FlowMapProgressbar';
import WFlowMapFlowField from './FlowMapFlowField';
import WFlowMapItemLabel from './FlowMapItemLabel';

export default {
  name: 'WFlowMapUserProcess',
  components: {
    WFlowMapProgressbar,
    WRscPerfEventTextLabel,
    WFlowMapFlowField,
    WFlowMapItemLabel,
  },
  props: {
    rscPerfData: {
      type: Object,
    },
    objtypeId: {
      type: String,
    },
    showFlowFieldLabel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      arrowSettings: {
        top: '100px',
        arrowDirection: 'arrow-right',
        arrowSize: 'small',
      },
    };
  },
  methods: {
    perfPercentage(perfKey) {
      if (isNil(perfKey)) {
        return 0;
      }
      const perfData = this.rscPerfData[perfKey];
      // FIXME:  성능 값이 없을 경우 어떻게 표현? 일단 0%으로 표현.
      if (isNil(perfData)) {
        return 0;
      }

      return parseFloat((perfData * 100).toFixed(2));
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/database-flow-map/components/FlowMapUserProcess.vue